import { app } from '../../../../../../../bootstrap/core';

import { createRequestPersonComponent } from './person.component';

app.component(createRequestPersonComponent.name, createRequestPersonComponent);
